var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2670_22218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.364 20C20.364 20.5304 20.1533 21.0391 19.7782 21.4142C19.4031 21.7893 18.8944 22 18.364 22H6.36401C5.83357 22 5.32487 21.7893 4.94979 21.4142C4.57472 21.0391 4.36401 20.5304 4.36401 20V4C4.36401 3.46957 4.57472 2.96086 4.94979 2.58579C5.32487 2.21071 5.83357 2 6.36401 2H13.364L20.364 9V10.9359",
    stroke: "#01295F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.364 2V9H20.364",
    stroke: "#01295F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72741 12.7114L10.7616 14.5005H10.8059L11.8511 12.7114H13.3831L11.6741 15.543L13.4384 18.3746H11.8677L10.8059 16.5662H10.7616L9.69976 18.3746H8.14017L9.89609 15.543L8.18441 12.7114H9.72741Z",
    fill: "#01295F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.091 12.7114H15.786L17.224 16.2177H17.2903L18.7283 12.7114H20.4233V18.3746H19.0905V14.896H19.0435L17.683 18.3387H16.8313L15.4708 14.8766H15.4238V18.3746H14.091V12.7114Z",
    fill: "#01295F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2771 18.3746V12.7114H22.6459V17.263H24.4697V18.3746H21.2771Z",
    fill: "#01295F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2670_22218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.364006)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXml);
export default __webpack_public_path__ + "static/media/XML.c540c8f428360fcc6a7e2318375e8c67.svg";
export { ForwardRef as ReactComponent };